import {
	Box,
	createTheme,
	CssBaseline, PaletteMode, Theme, ThemeProvider, useMediaQuery,
} from '@mui/material';
import React, { useEffect } from 'react';
import {
	AuthProvider,
	TitleBarProvider,
	useLanguage,
	SettingProvider,
} from '@Providers';
import { Toast, ErrorDialog } from '@Organisms';
import {} from './utils/extensions/string.extensions';
import { withContext, LoadingMessage } from '@Hocs';

import '@Localization';
import LocalStorageWrapper, { LocalStorageKeys } from '@LocalStorage';
import { getDesignTokens } from '@Theme';
import { useTranslation } from 'react-i18next';
import { useEffectCustom } from '@Hooks';
import { AppRouter } from '@Routes';

const App = () => {
	const [theme, setTheme] = React.useState<Theme>();
	const [mode, setMode] = React.useState<PaletteMode>();
	const { locale } = useLanguage();
	const { i18n } = useTranslation();

	const toggleColorMode = () => {
		setMode((prevMode) => {
			const nMode = prevMode === 'light' ? 'dark' : 'light';
			LocalStorageWrapper.set(LocalStorageKeys.THEME, nMode);
			return nMode;
		});
	};

	const isPrefsDark = useMediaQuery('(prefers-color-scheme: dark)');

	useEffect(() => {
		let initialMode = LocalStorageWrapper.get(LocalStorageKeys.THEME) as PaletteMode;
		if (!initialMode) {
			initialMode = isPrefsDark ? 'dark' : 'light';
		}
		setMode(initialMode);
	}, [isPrefsDark]);

	useEffectCustom(() => {
		const lang = i18n.language;
		document.documentElement.lang = lang;
		getDesignTokens(mode ?? 'light').then((th) => {
			setTheme(createTheme(th, locale));
		});
	}, [mode, locale]);

	return (
		<Box>
			{!theme ? <LoadingMessage /> : (
				<TitleBarProvider>
					<ThemeProvider theme={theme}>
						<SettingProvider updateUIMode={toggleColorMode}>

							<Toast />
							<ErrorDialog />
							<AuthProvider>
								<AppRouter />
								<CssBaseline />
							</AuthProvider>

						</SettingProvider>
					</ThemeProvider>
				</TitleBarProvider>
			)}
		</Box>
	);
};

export default withContext(App);
